import { Children as s } from "react";
const a = (t) => {
  const n = s.toArray(t).find((r) => {
    var o;
    return (o = r == null ? void 0 : r.props) == null ? void 0 : o.id;
  });
  return n ? n.props.id : "";
};
export {
  a as findFirstId
};
//# sourceMappingURL=index.es548.js.map
